import React, { useEffect, useState } from "react";
import { getEnlaceCongreso, postEnlaceCongreso, putEnlaceCongreso } from "../../componentes/http/actions/EnlaceCongresoAction";
import EditNoteIcon from "@mui/icons-material/EditNote";
import {
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Grid,
  Typography,
  Box,
  Snackbar,
  Alert,
  TablePagination,
  useMediaQuery,
  useTheme,
  Card,
  CardContent,
  CardActions,
  CircularProgress,
} from "@mui/material";
import NuevoEnlaceCongresoModal from "../../componentes/modal/EnlaceCongreso/NuevoEnlaceCongresoModal";
import EditarEnlaceCongresoModal from "../../componentes/modal/EnlaceCongreso/EditarEnlaceCongresoModal";
import FilterComponent from "../../componentes/data/FilterComponent";

const GestorEnlaceCongreso = () => {
  const [enlaceCongreso, setenlaceCongreso] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [enlaceCongresoSeleccionado, setEnlaceCongresoSeleccionado] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterHabilitado, setFilterHabilitado] = useState("todos");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    fetchenlaceCongreso();
  }, []);

  const fetchenlaceCongreso = () => {
    setIsLoading(true);
    getEnlaceCongreso(localStorage.getItem("token"))
        .then((response) => {
            setenlaceCongreso(response);
        })
        .catch((error) => {
            console.log(error);
        })
        .finally(() => {
            setIsLoading(false);
            setInitialDataLoaded(true);
        });
    };

  const filterOptions = [
    { value: "todos", label: "Todos" },
    { value: "habilitado", label: "Habilitados" },
    { value: "deshabilitado", label: "Deshabilitados" },
  ];

  const filteredEnlaceCongreso = enlaceCongreso
    .filter((enlaceCongreso) => {
      const matchesSearch = enlaceCongreso.titulo
        .toLowerCase()
        .includes(searchTerm.toLowerCase());
      const matchesFilter =
        filterHabilitado === "todos" ||
        (filterHabilitado === "habilitado" && enlaceCongreso.habilitado === true) ||
        (filterHabilitado === "deshabilitado" &&
          enlaceCongreso.habilitado === false);
      return matchesSearch && matchesFilter;
    })
    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  const handleSearchChange = (newSearchTerm) => {
    setSearchTerm(newSearchTerm);
    setPage(0); // Volver a la primera página al buscar
  };
  
  const handleFilterChange = (newFilter) => {
    setFilterHabilitado(newFilter);
    setPage(0); // Volver a la primera página al filtrar
  };

  //Modal de nuevo enlaceCongreso
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
//Modal de editar enlaceCongreso
    const handleOpenEditModal = (enlaceCongreso) => {
        setEnlaceCongresoSeleccionado(enlaceCongreso);
        setOpenEditModal(true);
    };
    const handleCloseEditModal = () => {
        setOpenEditModal(false);
        setEnlaceCongresoSeleccionado(null);
    };

  const handleNuevoEnlaceCongreso = async (enlaceCongreso) => {
    try {
      setIsLoading(true);
      await postEnlaceCongreso(localStorage.getItem("token"), enlaceCongreso);
      await fetchenlaceCongreso();
      handleCloseModal();
      setSnackbar({
        open: true,
        message: "Correo agregado con éxito",
        severity: "success",
      });
    } catch (error) {
      console.error("Error al agregar enlace congreso:", error);
      setSnackbar({
        open: true,
        message: "Error al agregar enlace congreso",
        severity: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditarEnlaceCongreso = async (editado) => {
    try {
      setIsLoading(true);
      await putEnlaceCongreso(localStorage.getItem("token"), editado);
      await fetchenlaceCongreso();
      handleCloseEditModal(); // Close the modal after successful edit
      setSnackbar({
        open: true,
        message: "Correo editado con éxito",
        severity: "success",
      });
    } catch (error) {
      console.error("Error al editar enlace congreso:", error);
      setSnackbar({
        open: true,
        message: "Error al editar enlace congreso",
        severity: "error",
      });
    } finally {
      setIsLoading(false);
    }
  }

  const renderMobileCard = (enlaceCongreso) => (
    <Card key={enlaceCongreso.id} sx={{ mb: 2 }}>
      <CardContent>
        <Typography variant="h6">{enlaceCongreso.titulo}</Typography>
        <Typography variant="body2" color="text.secondary">
          Correlativo: {enlaceCongreso.correlativo}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Etapa: {enlaceCongreso.etapa}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Boletín: {enlaceCongreso.boletin}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Fecha: {new Date(enlaceCongreso.fecha).toLocaleDateString()}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Cliente: {enlaceCongreso.nombreCliente}
        </Typography>
      </CardContent>
      <CardActions>
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={() => handleOpenEditModal(enlaceCongreso)}
        >
          <EditNoteIcon />
        </Button>
      </CardActions>
    </Card>
  );
  const renderNoDataMessage = () => (
    <TableContainer component={Paper}>
      <Box p={3} sx={{ 
        width: '100%', 
      }}>
        <Typography variant="body1" color="text.secondary">
          No se encontraron enlaces de congreso con los criterios de búsqueda actuales.
        </Typography>
      </Box>
    </TableContainer>
  );
  return (
    <Grid container direction="column" spacing={2} sx={{paddingTop: {xs: '20px', sm: '10px'}}}>
      <Grid item>
        <Grid container justifyContent="space-between" alignItems="center">
          <Typography variant="h4">Enlace Congreso</Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={handleOpenModal}
            disabled={isLoading}
          >
            Añadir enlace congreso
          </Button>
        </Grid>
      </Grid>
      <Grid item>
        <FilterComponent
          searchTerm={searchTerm}
          onSearchChange={handleSearchChange}
          filterValue={filterHabilitado}
          onFilterChange={handleFilterChange}
          filterOptions={filterOptions}
        />
      </Grid>
      <Grid item>
        {isLoading && !initialDataLoaded ? (
          <Box display="flex" justifyContent="center" p={3}>
            <CircularProgress />
          </Box>
        ) : isMobile ? (
          <>
          {filteredEnlaceCongreso.length > 0 ? (
            <Box>
              {filteredEnlaceCongreso
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map(renderMobileCard)}
            </Box>
            ) : (
              renderNoDataMessage()
            )}
            <TablePagination
              rowsPerPageOptions={[10, 25]}
              component="div"
              count={filteredEnlaceCongreso.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </>
        ) : (
          <>
          {filteredEnlaceCongreso.length > 0 ? (
            <>
            <TableContainer component={Paper}>
              <Table>
            <TableHead>
              <TableRow>
                <TableCell>Id</TableCell>
                <TableCell>Correlativo</TableCell>
                <TableCell>Título</TableCell>
                <TableCell>URL Cámara</TableCell>
                <TableCell>Etapa</TableCell>
                <TableCell>Sub Etapa</TableCell>
                <TableCell>Boletín</TableCell>
                <TableCell>Fecha</TableCell>                
                <TableCell>XML Senado</TableCell>
                <TableCell>Habilitado</TableCell>
                <TableCell>Cliente</TableCell>
                <TableCell>Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredEnlaceCongreso.map((enlaceCongreso, index) => (
                <TableRow key={index}>
                  <TableCell>{enlaceCongreso.id}</TableCell>
                  <TableCell>{enlaceCongreso.correlativo}</TableCell>
                  <TableCell>{enlaceCongreso.titulo}</TableCell>
                  <TableCell>{enlaceCongreso.url_camara}</TableCell>                 
                  <TableCell>{enlaceCongreso.etapa}</TableCell>
                  <TableCell>{enlaceCongreso.subEtapa}</TableCell>
                  <TableCell>{enlaceCongreso.boletin}</TableCell>
                  <TableCell>{new Date(enlaceCongreso.fecha).toLocaleDateString()}</TableCell>
                  <TableCell>{enlaceCongreso.xml_senado}</TableCell>
                  <TableCell>{enlaceCongreso.habilitado ? "Sí" : "No"}</TableCell>
                  <TableCell>{enlaceCongreso.nombreCliente}</TableCell>
                  <TableCell>
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                      <Button
                        variant="contained"
                        color="primary"
                        sx={{ mr: 1 }}
                        onClick={() => handleOpenEditModal(enlaceCongreso)}
                        startIcon={<EditNoteIcon />}
                      >
                        EDITAR
                      </Button>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
            </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 25, 50]}
              component="div"
              count={filteredEnlaceCongreso.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
            </>
          ) : (
            renderNoDataMessage()
          )}
          </>
          
        )}
      </Grid>
      <NuevoEnlaceCongresoModal
        open={openModal}
        onClose={handleCloseModal}
        onSubmit={handleNuevoEnlaceCongreso}
        isLoading={isLoading}
      />
      <EditarEnlaceCongresoModal
        open={openEditModal}
        onClose={handleCloseEditModal}
        onSubmit={handleEditarEnlaceCongreso}
        enlaceCongreso={enlaceCongresoSeleccionado}
      />
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Grid>
  );
};

export default GestorEnlaceCongreso;
